<template>
  <div>
    <v-card class="main-container">
        <v-card-text>
            <v-data-table
                v-model="selected_users"
                :style="{color: $mainColor}"
                :headers="current_headers"
                :items="filteredListUsers"
                :loading="preloaderYet"
                loading-text="Загрузка списка заявок ..."
                :items-per-page="50"
                :footer-props="{
                    itemsPerPageOptions: [50, 200, 500],
                    itemsPerPageText: 'кол-во на стр.:',
                }"
            >
              <template v-slot:top>
                <v-container>
                  <v-row v-if="is_moderator">
                    <v-col class="pt-2 pb-0" style="max-width: 250px;">
                        <v-btn
                            v-if="showAll"
                            text
                            small
                            target='_blank'
                            @click="showAll = false"
                            color="#16336e">
                            <v-icon>mdi-chevron-up</v-icon>скрыть отмененные<v-icon>mdi-chevron-up</v-icon>
                        </v-btn>
                        <v-btn
                            v-else
                            text
                            small
                            target='_blank'
                            @click="showAll = true"
                            color="#16336e">
                            <v-icon>mdi-chevron-down</v-icon>показать все<v-icon>mdi-chevron-down</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col class="pa-0" style="max-width: 180px;">
                        <v-select
                          v-model="type_filter"
                          :items="all_types"
                          item-text="name"
                          item-value="id"
                          small
                          dense
                        ></v-select>                      
                    </v-col>
                    <v-col class="pt-2 pb-0">
                      <v-btn
                        v-if="type_filter == 0 || type_filter == 2 || type_filter == 3 || type_filter == 4"
                          @click="uploadToExcel()"
                          x-small style="margin-left: 15px;">
                          загрузить в * excel
                      </v-btn>
                      <v-btn
                          v-if="type_filter == 2 || type_filter == 3"
                            @click="uploadThesis()"
                            x-small style="margin-left: 50px;">
                            скачать все Тезисы единым файлом
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </template>
            <template v-slot:body="{ items, isSelected, select}">
                <tbody>
                  <tr v-for="item in items" :key="item.id" :class="row_classes(item)">
                    <td>
                      <span @click="openDetailInfo(item.id)" style="cursor: pointer;">
                      {{ item.user_descr }}
                      </span>
                    </td>
                    <td>
                      <span @click="openDetailInfo(item.id)" style="cursor: pointer;">
                        {{ item.organization_id == 134 ? 'Другая: ' + item.other_org_descr : item.organisation }}
                      </span>
                    </td>
                    <!-- <td v-if="is_moderator">
                      <span @click="openDetailInfo(item.id)" style="cursor: pointer;">
                        {{ item.confirm_type > 0 ? get_type_descr(item.confirm_type) : get_type_descr(item.type) }}
                      </span>
                    </td> -->
                    <td v-if="is_moderator">
                      <v-tooltip left v-for=" n in item.speech_user_confirm" :key="'speech_user_confirm'+n">
                          <template v-slot:activator="{ on, attrs }">
                              <v-icon
                              medium
                              v-bind="attrs"
                              v-on="on"
                              :color="icon_color_new('user_confirm')"
                              >
                              mdi-account-tie-voice
                              </v-icon>
                          </template>
                          <span>подвержден пользователем</span>
                      </v-tooltip>
                      <v-tooltip left v-for=" n in item.speech_confirm" :key="'speech_confirm'+n">
                          <template v-slot:activator="{ on, attrs }">
                              <v-icon
                              medium
                              v-bind="attrs"
                              v-on="on"
                              :color="icon_color_new('confirm')"
                              >
                              mdi-account-tie-voice
                              </v-icon>
                          </template>
                          <span>утвержден модератором</span>
                      </v-tooltip>
                      <v-tooltip left v-for=" n in item.speech_new" :key="'speech_new'+n">
                          <template v-slot:activator="{ on, attrs }">
                              <v-icon
                              medium
                              v-bind="attrs"
                              v-on="on"
                              :color="icon_color_new('new')"
                              >
                              mdi-account-tie-voice
                              </v-icon>
                          </template>
                          <span>новый</span>
                      </v-tooltip>
                      <v-tooltip left v-for=" n in item.speech_reject" :key="'speech_reject'+n">
                          <template v-slot:activator="{ on, attrs }">
                              <v-icon
                              medium
                              v-bind="attrs"
                              v-on="on"
                              :color="icon_color_new('reject')"
                              >
                              mdi-account-tie-voice
                              </v-icon>
                          </template>
                          <span>отклонен </span>
                      </v-tooltip>
                      <!-- <v-tooltip left v-if="item.speech_new > 0 || item.speech_confirm > 0 || item.speech_reject > 0">
                          <template v-slot:activator="{ on, attrs }">
                              <v-icon
                              medium
                              v-bind="attrs"
                              v-on="on"
                              :color="icon_color(item.speech_new, item.speech_confirm, item.speech_reject)"
                              >
                              mdi-account-tie-voice
                              </v-icon>
                          </template>
                          <span>{{ item_text(item.speech_new, item.speech_confirm, item.speech_reject) }}</span>
                      </v-tooltip> -->
                      
                      <v-tooltip left v-for=" n in item.stand_user_confirm" :key="'stand_user_confirm'+n">
                          <template v-slot:activator="{ on, attrs }">
                              <v-icon
                              medium
                              v-bind="attrs"
                              v-on="on"
                              :color="icon_color_new('user_confirm')"
                              >
                              mdi-billboard
                              </v-icon>
                          </template>
                          <span>подвержден пользователем</span>
                      </v-tooltip>
                      <v-tooltip left v-for=" n in item.stand_confirm" :key="'stand_confirm'+n">
                          <template v-slot:activator="{ on, attrs }">
                              <v-icon
                              medium
                              v-bind="attrs"
                              v-on="on"
                              :color="icon_color_new('confirm')"
                              >
                              mdi-billboard
                              </v-icon>
                          </template>
                          <span>утвержден модератором</span>
                      </v-tooltip>
                      <v-tooltip left v-for=" n in item.stand_new" :key="'stand_new'+n">
                          <template v-slot:activator="{ on, attrs }">
                              <v-icon
                              medium
                              v-bind="attrs"
                              v-on="on"
                              :color="icon_color_new('new')"
                              >
                              mdi-billboard
                              </v-icon>
                          </template>
                          <span>новый</span>
                      </v-tooltip>
                      <v-tooltip left v-for=" n in item.stand_reject" :key="'stand_reject'+n">
                          <template v-slot:activator="{ on, attrs }">
                              <v-icon
                              medium
                              v-bind="attrs"
                              v-on="on"
                              :color="icon_color_new('reject')"
                              >
                              mdi-billboard
                              </v-icon>
                          </template>
                          <span>отклонен </span>
                      </v-tooltip>
                      <!-- <v-tooltip left  v-if="item.stand_new > 0 || item.stand_confirm > 0 || item.stand_reject > 0">
                          <template v-slot:activator="{ on, attrs }">
                              <v-icon
                              medium
                              v-bind="attrs"
                              v-on="on"
                              :color="icon_color(item.stand_new, item.stand_confirm, item.stand_reject)"
                              >
                              mdi-billboard
                              </v-icon>
                          </template>
                          <span>{{ item_text(item.stand_new, item.stand_confirm, item.stand_reject) }}</span>
                      </v-tooltip> -->
                    </td>
                    <td v-if="is_moderator">
                      <v-tooltip left  v-if="item.school_new > 0 || item.school_confirm > 0 || item.school_confirm_with_file > 0 || item.school_reject > 0">
                          <template v-slot:activator="{ on, attrs }">
                              <v-icon
                              medium
                              v-bind="attrs"
                              v-on="on"
                              :color="icon_color(item.school_new, item.school_confirm, item.school_confirm_with_file, item.school_reject)"
                              >
                              mdi-school
                              </v-icon>
                          </template>
                          <span>{{ item_text(item.school_new, item.school_confirm, item.school_confirm_with_file, item.school_reject) }}</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
        </v-card-text>

    </v-card>

    <v-dialog v-model="motivationCard" width="85%">
      <v-card class="main-card">
        <v-card-text>
          <div class="ma-3">
            <span v-html="motivation_text"></span>
          </div>
          <!-- <p style="margin-bottom: 0px; font-size: 16px;  margin-right: 30px;"> {{ motivation_text }}</p> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="motivationCard = false, motivation_text = ''">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog v-model="cancel_global_reg_dialog" persistent max-width="50%">
      <v-card>
        <v-card-title class="headline">Вы уверены, что хотите полностью отменить регистрацию на форум?
        </v-card-title>
        <!-- <v-card-text> -->
        <v-card-text>
          Полный отказ пользователю в участии в форуме. (спам и т.п.)
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="cancel_global_reg_dialog = false">Нет</v-btn>
          <v-btn color="red darken-1" text
            @click="cancel_global_reg(user_meeting_data.global.id)"> да, отменить регистрацию
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogUserCard" width="85%">
      <v-card class="main-card" v-if="user_meeting_data && user_meeting_data.global">
        <v-card-title text-color="#15336d">
            <v-icon left color="#15336d">mdi-label</v-icon>
            ID:{{ user_meeting_data.global.id }}
            {{ user_meeting_data.global.user_descr }}

        </v-card-title>
        <div class="d-flex flex-nowrap justify-space-between pa-2">
          
          <div style="width:50%;" class="pa-2">
            <v-card class="ma-2">
              <v-card-text>
                <p style="margin-bottom: 0px; font-size: 16px;"><b>Организация: </b> {{ user_meeting_data.global.organisation }}</p>
                <p style="margin-bottom: 0px; font-size: 16px;"><b>Телефон: </b> {{ user_meeting_data.global.phone_number }}</p>
                <p style="margin-bottom: 0px; font-size: 16px;"><b>E-mail: </b> {{ user_meeting_data.global.email }}</p>
                <p style="margin-bottom: 0px; font-size: 16px;"><b>Дата рождения: </b> {{ g.toDate(user_meeting_data.global.birth_date) }}</p>
                <v-spacer></v-spacer>
                <div class="pt-3"></div>
                <p style="margin-bottom: 0px; font-size: 16px;"><b>Дата регистрации: </b> {{ g.toDate(user_meeting_data.global.created_at) }}</p>
                <p style="margin-bottom: 0px; font-size: 16px;"><b>Планирует присутствовать: </b></p>
                <p  v-for="rec in selected_listen_sections" style="margin-left: 10px; margin-bottom: 0px; font-size: 16px;">{{ '  - ' }} {{ section_descr(rec) }}</p>

                
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text
                    @click="cancel_global_reg_dialog=true">{{"отклонить"}}
                  </v-btn>
                </v-card-actions>
              </v-card-text>
            </v-card>

          </div>

          <div style="width:50%;" class="suggested pa-2">
            <v-row v-if="user_meeting_data.school">
              <v-card style="width: 100%;" class="pa-2 ma-2" variant="tonal">
                <v-card-title>
                  <b style="margin-bottom: 0px; font-size: 16px;  margin-right: 30px;"> {{ user_meeting_data.school.is_confirm ? 'Подтвержден' : (user_meeting_data.school.is_rejected ? 'Отклонен' : 'В ожидании') }}</b>
                </v-card-title>
                <v-card-subtitle>
                  <p v-if="!edit_school_mode" style="margin-bottom: 0px; font-size: 16px;  margin-right: 30px;"> {{ school_types[user_meeting_data.school.type].name }}</p>
                  <div v-if="edit_school_mode==user_meeting_data.school.id">
                    <v-card-text>
                      <div class="input-container input-name modal-mul-select">
                        <v-select
                          v-model="new_school_type"
                          :items="school_types"
                          item-text="name"
                          item-value="id"
                          outlined
                          chips
                          required
                        ></v-select>
                      </div>
                    </v-card-text>
                    <v-card-text class="pt-0 pb-0">
                      <v-text-field
                        v-model="new_school_comment"
                        outlined
                        required
                        label="Комментарий"
                      ></v-text-field>
                    </v-card-text>
                    
                  </div>

                  <div v-if="user_meeting_data.school.file_id">
                    <template>
                        <v-row class="ma-0 mt-4">
                          <v-icon left>mdi-file</v-icon>
                          <p style="margin-bottom: 0px;">{{ user_meeting_data.school.file }}</p>
                        </v-row>
                        <v-row class="ma-0">
                          <v-badge style="margin-top: 0px !important;" color="red lighten-2" :content="'Анкета'" x-small inline>
                            <p style="margin-bottom: 0px;"></p>
                          </v-badge>
                          <v-btn @click="openFile(user_meeting_data.school.file)" icon>
                            <v-icon color="grey lighten-1">mdi-download</v-icon>
                          </v-btn>
                        </v-row>
                    </template>

                  </div>
                  <p v-else style="margin-bottom: 0px; font-size: 16px;  margin-right: 30px;"> - анкета не подгружена </p>
                </v-card-subtitle>

                <v-card-text v-if="user_meeting_data.school.org_comment">
                  <p style="margin-bottom: 0px; font-size: 16px;"><b>Комментарий: </b> {{ user_meeting_data.school.org_comment }}</p>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn v-if="!edit_school_mode" color="red darken-1" text @click="edit_school_mode = user_meeting_data.school.id, new_school_comment = user_meeting_data.school.org_comment, new_school_type = user_meeting_data.school.type">Изменить</v-btn>
                  <v-btn v-if="edit_school_mode==user_meeting_data.school.id"  color="yellow darken-1" text @click="edit_school_mode = null">Отмена</v-btn>
                  <v-btn v-if="edit_school_mode==user_meeting_data.school.id"  color="red darken-1" text
                    @click="change_school_usermeeting(user_meeting_data.school.id, 'reject')">{{"отклонить"}}
                  </v-btn>
                  <v-btn v-if="edit_school_mode==user_meeting_data.school.id"  color="green darken-1" text
                    @click="change_school_usermeeting(user_meeting_data.school.id, 'approve')">{{"подтвердить"}}
                  </v-btn>
                </v-card-actions>

                <v-card-text>
                  <v-btn color="gray darken-1" small
                    @click="show_motivation(user_meeting_data.school.school_motivation)">{{"мотивационное письмо"}}
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-row>

            <template v-if="user_meeting_data.speech.length > 0">
              <v-row v-for="sp_reg in user_meeting_data.speech" :key="sp_reg.id">
                <v-card style="width: 100%;"  class="pa-2 ma-2" variant="tonal">
                  <template v-if="edit_speech_mode==sp_reg.id">
                    <v-card-text class="pb-0">
                      <div class="input-container input-name modal-mul-select">
                        <v-select
                          v-model="new_speech_type"
                          :items="user_types"
                          item-text="name"
                          item-value="id"
                          outlined
                          chips
                          required
                        ></v-select>
                      </div>
                    </v-card-text>

                    <v-card-text class="pt-0 pb-0" v-if="new_speech_type == 2 || new_speech_type == 3">
                      <div class="input-container input-name modal-mul-select">
                        <v-select
                          v-model="new_speech_section"
                          :items="all_sections"
                          item-text="name"
                          item-value="id"
                          outlined
                          chips
                          required
                        ></v-select>
                      </div>
                    </v-card-text>
                    <v-card-text class="pt-0 pb-0" v-if="new_speech_type > 1">
                      <v-text-field
                        v-model="new_speech_comment"
                        outlined
                        required
                        name="input-7-4"
                        :label="new_speech_type == 9 ? 'Комментарий' : 'Дата выступления'"
                      ></v-text-field>
                    </v-card-text>
                  </template>
                  <template v-else>
                    <template v-if="sp_reg.is_rejected">
                      <p style="margin-bottom: 0px; font-size: 16px;"><b>Участие докладчиком отклонено модератором </b> </p>
                      <v-spacer></v-spacer>
                      <p style="margin-bottom: 0px; font-size: 16px;"><b>Формат участия: </b> {{ sp_reg.type == 2 ? 'Участник с докладом' : 'Участник со стендовым докладом'}}</p>
                      <p style="margin-bottom: 0px; font-size: 16px;"><b>Секция: </b> {{ section_descr(sp_reg.section_choice_id) }}</p>
                      <p style="margin-bottom: 0px; font-size: 16px;"><b>Название доклада: </b> {{ sp_reg.comments }}</p>
                      <p style="font-size: 16px;"><b>Комментарий: </b> {{ (sp_reg.org_comment && sp_reg.org_comment.length > 0) ? sp_reg.org_comment : ' отсутствует'}}</p>
                    </template>
                    <template v-else>
                      <template v-if="sp_reg.confirm_type == 1">
                        <p style="margin-bottom: 0px; font-size: 16px;"><b>Пользователь отказался от участия со стендовым докладом </b></p>
                        <p style="margin-bottom: 0px; font-size: 16px;"><b>Секция: </b> {{ section_descr(sp_reg.section_confirm_id) }}</p>
                        <p style="margin-bottom: 0px; font-size: 16px;"><b>Название доклада: </b> {{ sp_reg.comments }}</p>
                      </template>
                      <template v-if="sp_reg.confirm_type > 1">
                        <p style="margin-bottom: 0px; font-size: 16px;"><b>Пользователь подтвердил участие: </b> {{ sp_reg.is_confirm ? 'Да' : 'Еще нет' }}</p>
                        <p style="margin-bottom: 0px; font-size: 16px;"><b>Подтвержденный формат участия: </b> {{ sp_reg.confirm_type == 2 ? 'Участник с докладом' : 'Участник со стендовым докладом' }}</p>
                        <p style="margin-bottom: 0px; font-size: 16px;"><b>Секция: </b> {{ section_descr(sp_reg.section_confirm_id) }}</p>
                        <p style="margin-bottom: 0px; font-size: 16px;"><b>Название доклада: </b> {{ sp_reg.comments }}</p>
                        <p style="font-size: 16px;"><b>Дата выступления: </b> {{ (sp_reg.org_comment && sp_reg.org_comment.length > 0) ? sp_reg.org_comment : 'нет информации'}}</p>
                      </template>
                      <template v-if="sp_reg.confirm_type == 0">
                        <p style="margin-bottom: 0px; font-size: 16px;"><b>Формат участия: </b> {{ sp_reg.type == 2 ? 'Участник с докладом' : 'Участник со стендовым докладом'}}</p>
                        <p style="margin-bottom: 0px; font-size: 16px;"><b>Секция: </b> {{ section_descr(sp_reg.section_choice_id) }}</p>
                        <p style="margin-bottom: 0px; font-size: 16px;"><b>Название доклада: </b> {{ sp_reg.comments }}</p>
                        <p style="margin-bottom: 0px; font-size: 16px;"><b> формат участия: </b> {{ sp_reg.type == 2 ? 'Участник с докладом' : 'Участник со стендовым докладом' }}</p>
                      </template>

                    </template>

                    <div v-if="sp_reg.exp_file_id">
                      <template>
                          <v-row class="ma-0 mt-4">
                            <v-icon left>mdi-file</v-icon>
                            <p style="margin-bottom: 0px; cursor: pointer;" @click="openFile(sp_reg.exp_file)">{{ sp_reg.exp_file }}</p>
                          </v-row>
                          <v-row class="ma-0">
                            <v-badge style="margin-top: 0px !important;" color="red lighten-2" :content="'экспертное заключение'" x-small inline>
                              <p style="margin-bottom: 0px;"></p>
                            </v-badge>
                            <v-btn @click="openFile(sp_reg.exp_file)" icon>
                              <v-icon color="grey lighten-1">mdi-download</v-icon>
                            </v-btn>
                          </v-row>
                      </template>

                    </div>

                    <v-btn v-if="sp_reg.thesis_id > 0"  color="green darken-1" text
                      @click="openThesis(sp_reg.thesis_id)">{{"тезисы"}}
                    </v-btn> 


                  </template>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn v-if="!edit_speech_mode" color="red darken-1" text @click="edit_speech_mode = sp_reg.id, new_speech_type =sp_reg.confirm_type > 0 ? sp_reg.confirm_type : sp_reg.type, new_speech_section = sp_reg.confirm_type > 0 ? sp_reg.section_confirm_id : sp_reg.section_choice_id, new_speech_comment = sp_reg.org_comment">Изменить</v-btn>
                    <v-btn v-if="edit_speech_mode==sp_reg.id"  color="red darken-1" text @click="edit_speech_mode = null">Отмена</v-btn>
                    <v-btn v-if="edit_speech_mode==sp_reg.id"  color="green darken-1" text
                      @click="change_speech_usermeeting(sp_reg.id)">{{"Сохранить"}}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-row>
            </template>
          </div>

        </div>

      </v-card>

    </v-dialog>

    <v-dialog v-model="thesis_show_dialog" max-width="50%">
      <thesis-show
        :thesis_data="thesis_data"
        @closeDialog="thesis_show_dialog=false"
      />
    </v-dialog>

  </div>
</template>


<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex';
  import thesisShow from '../components/Common/ThesisShow.vue'

  export default {
    name: 'ModeratorTab2',
    components: {
      thesisShow,
    },
    data() {
      return {
        requests: [],
        listUsers: [],
        allListUsers: [],
        filteredListUsers: [],
        showAll: false,
        preloaderYet: false,
        disabledLoadYet: false,
        selected_users: [],

        current_index: 0,
        cur_meeting_id: 3,
        currentProposal: [],
        listRequestFormat: [],
        checkedItemTable: false,
        current_headers: [],
        is_moderator: false,
        headers: [
            { text: 'ФИО', sortable: true, value: 'user_descr'},
            { text: 'Организация', sortable: true, value: 'organisation'},
        ],
        full_headers: [
            { text: 'ФИО', sortable: true, value: 'user_descr'},
            { text: 'Организация', sortable: true, value: 'organisation'},
            // { text: 'Формат участия', sortable: true, value: 'confirm_type'},
            // { text: '', value: 'actions', sortable: false},
            { text: 'Доклад', value: 'actions1', sortable: false},
            { text: 'Школа', value: 'actions2', sortable: false}
        ],

        user_meeting_data: {},
        dialogUserCard: false,
        user_types: [
            {id: 9, name : '--- Отклонить доклад'},
            // {id: 1, name : 'Слушатель (без доклада)'},
            {id: 2, name : 'Участник с устным докладом'},
            {id: 3, name : 'Участник со стендовым докладом'},
        ],
        all_types: [
            {id: 0, name : '--- Все'},
            {id: 1, name : 'Слушатель'},
            {id: 2, name : 'Устно'},
            {id: 3, name : 'Стенд'},
            {id: 4, name : 'Школа'},
        ],
        type_filter: 0,

        new_user_type: 1,
        new_section: 0,
        new_org_comment: '',
        current_global_id: null,
        active_sections_list: {},
        all_sections: [],
        selected_listen_sections: [],

        thesis_data: {},
        thesis_show_dialog: false,

        school_types: [
          {id: 0, name : 'не выбрано'},
          {id: 1, name : 'Современные биотехнологии: повышение производительности разработок и производств'},
          {id: 2, name : 'Особенности генетических исследований лабораторных приматов'},
        ],
        edit_school_mode: null,
        new_school_type: null,
        new_school_comment: '',
        motivation_text: '',
        motivationCard: false,

        edit_speech_mode: null,
        new_speech_type: null,
        new_speech_section: null,
        new_speech_comment: '',

        cancel_global_reg_dialog: false,
        
      };
    },
    beforeMount() {
      this.loadNewRequest();
      this.current_headers = this.headers;
    },

    mounted() {
      this.update_section_list()
    },
 
    watch: {
      GETTERS_SECTIONS(val) {
        this.update_section_list()
      },

      GETTERS_CURRENT_USER(val){
        this.update_permissions()
      },

      type_filter(val){
        this.filter_list()
      },
      showAll(val){
        this.filter_list()
      },
    },

    computed: {
      ...mapGetters([
        'GETTERS_LOGIN', 
        'GETTERS_CURRENT_USER',
        'GETTERS_SECTIONS',
      ]),
    },
    methods: {
      ...mapActions([
        'GET_LIST_USER_MEETING',
        'UPLOAD_LIST_TO_EXCEL',
        'UPLOAD_LIST_TO_DOCX',
        'GET_USERMEETING_ALL',
        'CHANGE_USERMEETING',
        'LOAD_THESIS_REC',
        'UPLOAD_THESIS_TO_DOCX',
      ]),
      ...mapMutations([
        'UPDATE_OVERLAY',
        'UPDATE_BASE_PROPOSAL_ID',
      ]),

      change_school_usermeeting(school_id, action){

        this.edit_school_mode = null

        var data = {
          type: 'change_school',
          school_reg_id: school_id,
          global_reg_id: this.current_global_id,
          action: action,
          new_school_type: this.new_school_type,
          new_school_comment: this.new_school_comment,
        }

        this.UPDATE_OVERLAY(true)
        this.CHANGE_USERMEETING(data)
          .then((res) => {
            if(res.status != 'ok'){
              console.log('eee', res.error);
              this.$messageHelper(res.error, 'error', 4000);
            }
            this.UPDATE_OVERLAY(false)
            this.edit_school_mode = null
            this.loadNewRequest();
            this.openDetailInfo(this.current_global_id)
          })
          .catch(() =>{
            this.edit_school_mode = null
            this.UPDATE_OVERLAY(false)
          });
        
      },

      _updateText(str){
        var str2 = str
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;')
          .replace(/`/g, '&#x60;');
        str2 = str2.replace(/\n/g, '\u003cbr\u003e')
        return str2
      },

      show_motivation(text){
        this.motivation_text = this._updateText(text)
        this.motivationCard = true
      },

      icon_color(is_new, confirm, with_file, reject){
        if(is_new > 0){
          // return 'yellow'
          return '#ebd93a'
        }
        else if(confirm > 0){
          return 'blue'
        }
        else if(with_file > 0){
          return 'green'
          // return '#b604f3'
        }
        else if(reject > 0){
          return 'red'
        }
        else
          return 'gray'
      },

      icon_color_new(type){
        if(type == 'user_confirm'){
          // return 'yellow'
          return 'green'
        }
        else if(type == 'confirm'){
          return 'blue'
        }
        else if(type == 'new'){
          return '#ebd93a'
        }
        else if(type == 'reject'){
          return 'red'
        }
        else
          return 'gray'
      },

      item_text(is_new, confirm, with_file,  reject){
        if(is_new > 0){
          // return 'yellow'
          return 'Есть новые'
        }
        else if(confirm > 0){
          return 'Принят'
        }
        else if(with_file > 0){
          return 'Подгружена анкета'
        }
        else if(reject > 0){
          return 'Все отклонены'
        }
        else
          return ''
      },

      async openDetailInfo(id) {
        this.UPDATE_OVERLAY(true)
        this.GET_USERMEETING_ALL(id)
        .then((res) => {
          this.UPDATE_OVERLAY(false)
          this.current_global_id = id
          this.user_meeting_data = res

          this.selected_listen_sections = []
          var ls = []
          if(this.user_meeting_data.global.listen_sections !== null)
            ls = this.user_meeting_data.global.listen_sections.split(', ')
          ls.forEach((item) => {
            this.selected_listen_sections.push(parseInt(item))
          })

          this.dialogUserCard = true
        })
        .catch(() =>{
          this.UPDATE_OVERLAY(false)
        });
      },

      openThesis(id){
        this.UPDATE_OVERLAY(true)
        this.LOAD_THESIS_REC(id)
        .then((res) => {
          this.thesis_data = res;
          this.thesis_show_dialog = true;
          this.UPDATE_OVERLAY(false)
        })
        .catch((e) => {
          console.log('eee', e);
          this.$messageHelper(e.message, 'error', 4000);
          this.UPDATE_OVERLAY(false)
        });

      },

      get_type_descr(id){
        if(id == 2)
          return 'Устно'
        else if(id == 3)
          return 'Стенд'
        else
          return 'Слушатель'
      },

      section_descr(id){
        if(id > 0)
          return this.active_sections_list[id].name
        else
          return 'Не указано при регистрации!'
      },

      cancel_global_reg(){
        var data = {
          type: 'cancel_global_reg',
          global_reg_id: this.current_global_id,
        }

        this.UPDATE_OVERLAY(true)
        this.CHANGE_USERMEETING(data)
          .then((res) => {
            if(res.status != 'ok'){
              console.log('eee', res.error);
              this.$messageHelper(res.error, 'error', 4000);
            }
            this.UPDATE_OVERLAY(false)
            this.cancel_global_reg_dialog = false
            this.dialogUserCard = false
            this.loadNewRequest();
          })
          .catch(() =>{
            this.cancel_global_reg_dialog = false
            this.UPDATE_OVERLAY(false)
          });

      },

      change_speech_usermeeting(speech_reg_id){
        var data = {
          type: 'change_speech',
          speech_reg_id: speech_reg_id,
          global_reg_id: this.current_global_id,
          new_type: this.new_speech_type,
          new_section: this.new_speech_section,
          new_org_comment: this.new_speech_comment,
        }

        this.UPDATE_OVERLAY(true)
        this.CHANGE_USERMEETING(data)
          .then((res) => {
            if(res.status != 'ok'){
              console.log('eee', res.error);
              this.$messageHelper(res.error, 'error', 4000);
            }
            this.UPDATE_OVERLAY(false)
            this.edit_speech_mode = null
            this.loadNewRequest();
            this.openDetailInfo(this.current_global_id)
          })
          .catch(() =>{
            this.edit_speech_mode = null
            this.UPDATE_OVERLAY(false)
          });

      },

      update_section_list(){
        this.all_sections = []
        this.GETTERS_SECTIONS.forEach((item) => {
          // if(item.is_active && item.is_public){
            this.all_sections.push(item)
          // }
          this.active_sections_list[item.id] = item
        })

      },

      loadNewRequest(index = 0) {
        const stop = false
        this.current_index = index
  
        this.preloaderYet = true;
        this.disabledLoadYet = false;
        this.allListUsers = [];

        this.update_permissions()
  
        this.GET_LIST_USER_MEETING({meeting_id: this.cur_meeting_id})
          .then((res) => {
            this.preloaderYet = false;
            this.disabledLoadYet = true;
            this.allListUsers = res;
            this.filter_list()

            this.update_section_list()
          })
          .catch(() => this.preloaderYet = false);
        // }
  
      },

      filter_list(){
        this.filteredListUsers = []
        if(this.showAll && this.type_filter == 0){
          this.filteredListUsers = this.allListUsers
        }
        else{
          if(this.type_filter == 1){
            this.allListUsers.forEach((item, i) => {
              if(!this.showAll && (!item.is_active || item.is_rejected))
                return
              if((item.school_new > 0 || item.school_confirm > 0 || item.school_confirm_with_file > 0 || item.speech_new > 0 || item.speech_confirm > 0 || item.stand_new > 0 || item.stand_confirm > 0 || item.stand_user_confirm > 0 || item.speech_user_confirm > 0))
                return

              this.filteredListUsers.push(item)              
            })
          }
          else if(this.type_filter == 2){
            this.allListUsers.forEach((item, i) => {
              if(!this.showAll && (!item.is_active || item.is_rejected))
                return
              if(item.speech_new > 0 || item.speech_confirm > 0 || item.speech_reject > 0 || item.speech_user_confirm > 0)
                this.filteredListUsers.push(item)              
            })
          }

          else if(this.type_filter == 3){
            this.allListUsers.forEach((item, i) => {
              if(!this.showAll && (!item.is_active || item.is_rejected))
                return
              if(item.stand_new > 0 || item.stand_confirm > 0 || item.stand_reject > 0 || item.stand_user_confirm > 0)
                this.filteredListUsers.push(item)              
            })
          }

          else if(this.type_filter == 4){
            this.allListUsers.forEach((item, i) => {
              if(!this.showAll && (!item.is_active || item.is_rejected))
                return
              if(item.school_new > 0 || item.school_confirm > 0 || item.school_confirm_with_file > 0 || item.school_reject > 0)
                this.filteredListUsers.push(item)              
            })
          }
          else{
            this.allListUsers.forEach((item, i) => {
              if(!this.showAll && (!item.is_active || item.is_rejected))
                return
              this.filteredListUsers.push(item)
            })
          }

        }        
      },

      update_permissions(){
        if (this.GETTERS_CURRENT_USER !== null) {
          try {
            for (var index = 0; index < this.GETTERS_CURRENT_USER.role.length; index++) {
              const element = this.GETTERS_CURRENT_USER.role[index];

              if (element.access_rights == 'moderator') {
                this.is_moderator = true;
              }
            }
            if(this.is_moderator)
              this.current_headers = this.full_headers

          } catch (ex) {
            console.log('ex ---> ', ex);
          }
        }
      },

      uploadToExcel() {
        this.UPDATE_OVERLAY(true)
        this.UPLOAD_LIST_TO_EXCEL(this.type_filter)
          .then((res) => {
            this.UPDATE_OVERLAY(false)
            window.open(res.url, '_blank');
          })
          .catch((e) => {
            this.UPDATE_OVERLAY(false)
          });
      },

      uploadThesis(){
        this.UPDATE_OVERLAY(true)
        this.UPLOAD_THESIS_TO_DOCX({id: -13, type_filter: this.type_filter})
          .then((res) => {
            this.UPDATE_OVERLAY(false)
          })
        .catch((e) => this.UPDATE_OVERLAY(false));

      },

      openFile(fileName) {
        window.open(`https://genom.kcsni-service.ru/media/${fileName}`, '_blank')
      },


      addIdSwitchRequest(id) {
        this.requests = [];
        if (this.requests.length !== 0) {
          this.requests.forEach((item) => {
            Number(item) !== Number(id) ? this.requests.push(id) : null;
          });
        } else this.requests.push(id);
      },
      
      row_classes(item) {
        if(item.is_rejected || !item.is_active)
          return "red_bg";
        // else if(item.confirm_type == 0)
        //   return "yellow_bg";
        else
          return "white_bg";
      },  
    },
  };

</script>
<style scoped>

.green_bg {
  background-color: #93e093;
}
.red_bg {
  background-color: #d97575;
}
.yellow_bg {
  background-color: #f0f07a;
}
.white_bg {
  background-color: rgb(255, 255, 255);
}
.green-bg {
  /* `!important` is necessary here because Vuetify overrides this */
  display: table-row;
  background: rgb(106, 246, 106) !important; 
}

.main-container{
    border-radius: 13px!important;
}
.headline{
    font-size: 12px;
  }
.btn-load-more{
    color: rgb(22, 51, 110);
    border-radius: 0px;
    box-shadow: none;
    margin-bottom: -26px;
    width: 100%;
    z-index: 1;
}
.v-card{
  margin-bottom: 30px;
    border: 0px;
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
    letter-spacing: 0.5px;
    border-radius: 13px;
    -webkit-box-shadow: 1px 5px 24px 0 rgba(124,77,255,0.05);
    box-shadow: 1px 5px 24px 0 rgba(124,77,255,0.05);
}
.new-proposal{
  background-color: rgba(22, 51, 110,0.2);
  border-radius: 0px 8px 8px 0px;
  margin-left: 0px !important;
  margin-bottom: 0px !important;
  margin-top: 14px !important;

}
.new-proposal:hover{
  -webkit-transform: translateY(-2px);
  transform: translateY(-2px);
}

</style>
<style>
.v-application .v-tabs-slider-wrapper {
    color: #4dbee1 !important;
}
</style>